import { find } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { Icon } from '../icons';
import { navDefaultProps } from './nav-prop-types';
import { Pill } from '../pill';

const MoreSelect = ({ selectRef, selectedSectionId, navItems, children, isOpen, onClick }) => {
  if (!children) return null;

  return (
    <Select>
      <Pill
        initialText="More"
        key="more"
        isActive={!!find(navItems, navItem => navItem.id === selectedSectionId)}
        onClick={() => onClick()}
        rightIcon={<Icon name="chevron" ml="4px" fill="currentColor" height="24px" width="24px" aria-hidden="true" />}
        outline={false}
      />
      <SelectItems ref={selectRef} isOpen={isOpen}>
        {children}
      </SelectItems>
    </Select>
  );
};

const SelectItems = styled.div`
  align-items: flex-start;
  background-color: white;
  border-radius: 2px;
  display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  flex-direction: column;
  padding: 16px;
  position: absolute;
  right: 0;
  top: 59.95px;
  z-index: 30;
  min-width: 328px;
  border-radius: 24px;

  @media (max-height: 700px) {
    max-height: 320px;
    overflow-y: auto;
  }
`;

const Select = styled.div`
  display: flex;
  position: relative;
`;

MoreSelect.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  navItems: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  selectRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]).isRequired,
  selectedSectionId: PropTypes.string,
};

MoreSelect.defaultProps = navDefaultProps;

export { MoreSelect };
